import { deleteDesignAPI } from '@/api/designs';
import { deleteDesignAction } from '../designerReducer';

export const deleteDesign =
  ({ designId, token, activeProfileId }) =>
  async dispatch => {
    const res = await deleteDesignAPI({
      designId,
      profileId: activeProfileId,
      token
    });

    if (!res.error) {
      dispatch(deleteDesignAction(designId));
    } else {
      // dispatch error
    }
  };
